<template>
    <div class="todo">
        <div class="primary">
            <input type="checkbox" :checked="todo.klaar" @change="toggleKlaar(todo)">
            <span :class="{ klaar: todo.klaar, belangrijk: todo.belangrijk}">{{ todo.todo }}</span>
        </div>
        
        <div class="primary">
            <div v-if="!todo.klaar" class="option orange" :class="{belangrijk: todo.belangrijk}" @click="toggleBelangrijk(todo)">
                <span style="color:orange;font-weight:600;">!</span>
            </div>
            <div class="option red" @click="verwijderTodo(todo.id)">
                <img src="@/assets/trashcan-ico-red.png">
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'BetaTodoItem',
    props: { todo: Object },
    methods: {
        ...mapActions([
            'voegTodoToe',
            'verwijderTodo',
            'toggleBelangrijk',
            'toggleKlaar',
        ])
    }

}
</script>

<style>
    .todo {
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        border-radius: 6px;
    }
    .todo:hover {
        background-color: #ECF3FC;
    }
    .todo .primary {
        display: flex;
        align-items: center;        
    }
    .klaar {
        text-decoration: line-through;
    }
    .option {
        height: 30px;
        width: 30px;
        border-radius: 6px;
        padding: 6px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        filter: grayscale();
        opacity: .6;
        transition: .1s;
    }
    .option:hover {
        filter: none;
        opacity: 1;
    }
    .option.red:hover {
        background-color: #EFBEC0;
    }
    .option.orange:hover {
        background-color: #FFE4C9;
    }
    .option.belangrijk {
        color: orange !important;
        filter: none;
        opacity: 1;
    }
    span.belangrijk {
        color: orange;
    }
    .option.orange.belangrijk:hover {
        background-color: #EFBEC0;
    }
</style>